import { Icon } from './Icon.js';

type Props = {
  known: number;
  unknown: number;
  unsure: number;
  onHome: () => void;
  onReview: () => void;
};

export function DoneCard({ known, unknown, unsure, onHome, onReview }: Props): JSX.Element {
  return (
    <div className="flex-1 w-full flex flex-col items-center justify-between px-6 pb-[max(20px,env(safe-area-inset-bottom))]">
      <div className="flex-1 flex items-center justify-center w-full">
        <div className="w-full max-w-card bg-surface border border-border rounded-2xl p-6 flex flex-col gap-5">
          <h1 className="text-title text-primary text-center">本次完成</h1>
          <div className="h-px bg-border" />
          <div className="grid grid-cols-3 text-center">
            <Stat icon={<Icon name="check" size={20} />} label="认识" value={known} />
            <Stat icon={<Icon name="x" size={20} />} label="不会" value={unknown} />
            <Stat label="不确定" value={unsure} symbol="?" />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-around w-full pt-6">
        <RoundButton ariaLabel="去日常复习" onClick={onReview}>
          <Icon name="book" size={22} />
        </RoundButton>
        <RoundButton ariaLabel="回首页" onClick={onHome}>
          <Icon name="home" size={22} />
        </RoundButton>
      </div>
    </div>
  );
}

function Stat({
  icon,
  symbol,
  label,
  value,
}: {
  icon?: JSX.Element;
  symbol?: string;
  label: string;
  value: number;
}): JSX.Element {
  return (
    <div className="flex flex-col items-center gap-1">
      <div className="text-secondary h-6 flex items-center justify-center">
        {icon ?? <span className="text-[18px] leading-none">{symbol}</span>}
      </div>
      <div className="text-primary text-[28px] font-semibold leading-none">{value}</div>
      <div className="text-secondary text-hint">{label}</div>
    </div>
  );
}

function RoundButton({
  ariaLabel,
  onClick,
  children,
}: {
  ariaLabel: string;
  onClick: () => void;
  children: JSX.Element;
}): JSX.Element {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      className="h-12 w-12 rounded-full flex items-center justify-center border bg-surface text-primary border-border active:bg-surface-2"
    >
      {children}
    </button>
  );
}
